import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import TextEditor from '../../shared/TextEditor';
import { color } from '../../../app/theme';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'Welcome',
  },
);

const Welcome = ({ welcomeMessage, onChange, isSaved, disabled }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:triggerSettingContainer.welcome`)}
        isRequired
      />
      <TextEditor
        onChange={v => onChange({ welcomeMessage: v })}
        origriData={welcomeMessage}
        placeholder={t(`${pathKey}:triggerSettingContainer.welcomePlaceholder`)}
        maxLength={600}
        isError={isSaved && !welcomeMessage}
        style={{ width: 584 }}
        disabled={disabled}
      />
    </div>
  );
};

export default Welcome;
